import React, { Component } from "react"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import { Breadcrumb, BreadcrumbItem, Col, Row } from "reactstrap"

import battlefieldSanta from '../assets/animation/battlefield.png';
import prioritySanta from '../assets/animation/priority.png';
import allSanta from '../assets/animation/all.png';
import MySanta from './ui/santa';
class Breadcrumbs extends Component {
  render() {
    return (
      <React.Fragment>
        <Row>
          <Col lg="12">
            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
              <Row>
                <Col lg="12" className="d-sm-flex justify-content-between align-items-center">
                  <h4 className="mb-0 font-size-18">{this.props.breadcrumbItem}</h4>
                  {/* </Col><Col lg="3"> */}
                  {/* <MySanta imageSanta={this.props.pg==='btl' ? battlefieldSanta : this.props.pg==='pr' ? prioritySanta : allSanta } /> */}
                </Col>

              </Row>
              <div className="page-title-right">
                <Breadcrumb listClassName="m-0">
                  <BreadcrumbItem>
                    <Link to="#">{this.props.title}</Link>
                  </BreadcrumbItem>
                  <BreadcrumbItem active>
                    <Link to="#">{this.props.breadcrumbItem}</Link>
                  </BreadcrumbItem>
                </Breadcrumb>
              </div>
            </div>
          </Col>
        </Row>

        {/* <Row>
          <Col lg="3"><h4 className="mb-0 font-size-18">{this.props.breadcrumbItem}</h4></Col>
          <Col lg="2"><MySanta imageSanta={this.props.pg==='btl' ? battlefieldSanta : this.props.pg==='pr' ? prioritySanta : allSanta } /></Col>
          <Col lg="7">
            <div className="page-title-right">
              <Breadcrumb listClassName="m-0">
                <BreadcrumbItem>
                  <Link to="#">{this.props.title}</Link>
                </BreadcrumbItem>
                <BreadcrumbItem active>
                  <Link to="#">{this.props.breadcrumbItem}</Link>
                </BreadcrumbItem>
              </Breadcrumb>
            </div>
          </Col>
        </Row> */}





        {/* <MySanta imageSanta={battlefieldSanta} left={'170px'} top={'12px'}/> */}
        {/* <MySanta imageSanta={prioritySanta} left={'220px'} top={'17px'}/> */}
        {/* <MySanta 
          imageSanta={this.props.pg==='btl' ? battlefieldSanta : this.props.pg==='pr' ? prioritySanta : allSanta } 
          top={this.props.pg==='btl' ? '12px' : this.props.pg==='pr' ? '17px' : '15px' } 
          left={this.props.pg==='btl' ? '170px' : this.props.pg==='pr' ? '220px' : '200px' } 
        /> */}
      </React.Fragment>
    )
  }
}

Breadcrumbs.propTypes = {
  breadcrumbItem: PropTypes.string,
  title: PropTypes.string,
  pg: PropTypes.string
}

export default Breadcrumbs
